


































import Vue from 'vue';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';
import ObjectMapper from '@/components/object_mapper/ObjectMapper.vue';
import { sendRequest } from '../../../utils/client/client';

export default Vue.extend({
  name: 'SurveyAnswerMapping',
  components: {
    ObjectMapper,
    LoadingSpinner,
    GenericCard,
  },
  props: {
    surveyResponseId: {
      type: String,
      required: true,
    },
    surveyAnswerId: {
      type: Number,
      required: true,
    },
    objectType: {
      type: Object,
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mappingObjects: [],
      leftColumnObjects: [],
      rightColumnObjects: [],
      apiEndpoints: {
        mappedObjects: '',
        relevantFilter: '',
      },
      availableMapTypes: {},
      loading: true,
      saving: false,
    };
  },
  computed: {
    requestUrl() {
      return `/object_mapper/api/mapped_objects/SurveyAnswer/${this.surveyAnswerId}/${this.objectType.model}`;
    },
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Medium });
    this.getMappingObjects();
  },
  methods: {
    async getMappingObjects() {
      try {
        const responseData = await sendRequest({
          method: 'GET',
          url: this.requestUrl,
        });
        this.rightColumnObjects = responseData.mapping_objects.map(o => ({ ...o, selected: false }));
      } catch {
        this.showError();
      } finally {
        this.loading = false;
      }
    },
    async saveMappingObjects() {
      if (!this.mappingObjects.length) {
        this.$emit('close');
        return;
      }
      this.saving = true;
      try {
        await sendRequest({
          method: 'POST',
          url: this.requestUrl,
          data: {
            mapping_objects: this.mappingObjects.map(o => ({ identifier: o.identifier, mapped: o.mapped, id: o.id })),
          },
          headers: {
            'X-CSRF-Token': this.csrf,
          },
        });
        window.location.href = `/sor/info/SurveyResponse/${this.surveyResponseId}/responses`;
      } catch {
        this.showError();
      }
    },
    cancel() {
      this.$emit('close');
    },
    onMappingItems({ mapped, unmapped }) {
      this.mappingObjects = [...mapped, ...unmapped];
    },
    showError() {
      window.GGRC.Notify({
        type: 'error',
        message: 'Oops, something went wrong.',
      });
    },
  },
});
